import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { captureAttributionFromLocation } from '../utils/attribution';
import {
  hasAnalyticsConsent,
  loadGoogleAnalytics,
  trackPageView,
} from '../utils/googleAnalytics';

/** Odsłony przy nawigacji SPA (React Router) — po zgodzie na cookie. */
const GoogleAnalyticsPageViews: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    captureAttributionFromLocation();
  }, [location.pathname, location.search]);

  useEffect(() => {
    if (!hasAnalyticsConsent()) {
      return;
    }
    const path = `${location.pathname}${location.search}`;
    void loadGoogleAnalytics()
      .then(() => {
        trackPageView(path);
      })
      .catch(() => {
        /* ignoruj */
      });
  }, [location.pathname, location.search]);

  return null;
};

export default GoogleAnalyticsPageViews;
